import { createContext, useContext } from "react";
import { BootstrapContext } from "./BootstrapContext";

export const EnvFeatureFlagContext = createContext();

export const EnvFeaturesProvider = ({ children }) => {
  const { envFeatureFlags, isSuccess } = useContext(BootstrapContext);

  return (
    <EnvFeatureFlagContext.Provider
      value={{
        remediationsDemoMode: envFeatureFlags.remediationsDemoMode || false,
        scenariosDemoMode: envFeatureFlags.scenariosDemoMode || false,
        scenariosSingleMode: envFeatureFlags.scenariosSingleMode || false,
        businessValueMode: envFeatureFlags.businessValueMode || false,
        featureFlagsAreAvailable: isSuccess,
        postureTrendChart: envFeatureFlags.postureTrendChart || false,
        nistControlDemo: envFeatureFlags.nistControlDemo || false,
        isActiveRds: envFeatureFlags.isActiveRds || false,
      }}
    >
      {children}
    </EnvFeatureFlagContext.Provider>
  );
};
